export default {
	SubmitDeclaration: 'Submit a declaration',
	AddTaxPaper: 'Prepare a deposit note',
	AddTaxPaperNowAcronym: 'Prepare a deposit note on behalf of',
	Later: 'Not now',
	VerifyButton: 'Authentication',
	Cancel: 'Cancel',
	Confirm: 'Confirm',
	SelectCompany: 'Select company',
	ViewProcedureHere: 'You can review the process here',
	User: {
		ListTaxCode: 'List of tax code',
		Change: 'Change',
		UsageAgreement: 'Terms of use',
		PrivacyPolicy: 'Personal data protection policy',
		LogOut: 'Log out'
	},
	Verify: {
		AccuracyInfo: 'Verify information',
		InputVerifyHasSend: type =>
			`Enter the authentication code that was sent to ${type == 2 ? 'phone number' : 'email'}`,
		NotMyUser: type => `Isn't this ${type == 2 ? 'phone number' : 'my email'}`,
		VerifyCode: 'Authentication code',
		NotTakeCode: 'Did not receive a code?',
		Resend: 'Send again',
		PhoneNoneActive: 'Unverified phone number',
		ActiveToLogin: (type, value) =>
			`Verify now to login by using ${type == 2 ? 'phone number' : 'email'
			} <strong>${value}</strong> from the next time`,

		EmailNoneActive: 'Unverified email'
	},
	GuideOnline: 'User manual (F1)',
	StaffOnFaceBook: 'Facebook digital advisor',
	CommunitySupport: 'Free software MISA support community',
	ForumSupportMisa: 'MISA forum',
	Switchboards: 'MISA call center',
	NoDataDownload: 'There is no data to download. Please check export conditions!',
	NoDataDownloadFile: 'There is no data to download. Please check download data!',
	NotHaveName: 'No name',
	NotHaveEmail: 'No email',
	NotHavePhoneNumber: 'No phone number',
	NotHaveTaxCode: 'No tax code',
	FullName: 'Full name',
	PhoneNumber: 'Phone number',
	Company: 'Company',
	Address: 'Address',
	Version: 'Version',
	Feedback: 'Feedback',
	LogOut: 'Log out',
	AdviseUse: 'Usage advice',
	OtherFeature: 'Other features',
	AllApp: 'Menu applications',
	NewFeature: 'New features',
	PopularQuestion: 'FAQ (F2)',
	Notification: 'Notification',
	TitleApp: 'MISA meInvoice',
	LicensePayment: 'License & Payment',
	ChangePassword: 'Change password',
	AccountSetting: 'Account settings',
	SecuritySetting: 'Security settings',
	IntroductionEarnPoints: 'Introduction to earn points',
	Language: lang => `Language: ${lang}`,
	LanguageDropdown: {
		vi: 'Vietnamese',
		en: 'English'
	},
	Started: 'Start using',
	TermOfService: 'Term of service',
	TermOfPurchase: 'Term of purchase',
	PrivacyPolicy: 'Personal data protection policy',
	TitleTermOfUse: 'Confirm personal data protection policy and license agreement',
	TitleTermOfService: 'Confirm the license agreement',
	TitlePrivacy: 'Confirm personal data protection policy',
	LicenseAgreement: 'License Agreement',
	and: 'and',
	ProductMeinvoice: 'MISA meInvoice',
	ContentTermOfUse1: `According to Vietnamese law, MISA adds the`,
	ContentTermOfUse2: 'By clicking on Confirm, you agree to the terms of our Privacy Policy and License Agreement.',
	ContentPrivacy2: 'By clicking on Confirm, you agree to our terms of Privacy Policy.',
	ContentTermOfService2: `By clicking on Confirm, you agree to the terms of our License Agreement.`,
	CustomerSupport: 'Supporting hotline',
	LicenseWarning: {
		ExpiredInvoiceDate: 'Your license and einvoices have expired. Please extend for smooth operation.',
		ExpiredDate: 'Your license has expired. Please extend for smooth operation.',
		ExpiredInvoice: 'Your einvoice has been used up. Please buy more for smooth operation.',
		ExpiredCommingInvoiceDate:
			'Your license and einvoices are about to expire. Please extend for smooth operation.',
		ExpiredComingdDate: numberDate =>
			numberDate > 1
				? `You have ${numberDate} days left of free trial. Please buy a license for smooth operation.`
				: `You have only 1 day left of free trial. Please buy a license for smooth operation.`,
		ExpiredCommingInvoice: 'The number of einvoices is about to be used up. Please buy more for smooth operation.',
		ExpiredInvoiceDateTrial:
			'Your free trial period and einvoices have expired. Please buy a license for smooth operation.',
		ExpiredDateTrial: 'Your free trial period has expired. Please buy a license for smooth operation.',
		ExpiredInvoiceTrial: 'Your einvoices have been used up. Please buy a license for smooth operation.',
		ExpiredCommingInvoiceDateTrial:
			'Your free trial period and einvoices are about to expire. Please buy a license for smooth operation.',
		ExpiredComingdDateTrial: numberDate =>
			numberDate > 1
				? `You have ${numberDate} days left of free trial. Please buy a license for smooth operation.`
				: `You have only 1 day left of free trial. Please buy a license for smooth operation.`,
		ExpiredCommingInvoiceTrial:
			'Your invoice quantity is running out. Please upgrade to the official version to avoid work interruption.',
		Extend: 'Extend now',
		BuyMore: 'Buy more now',
		Update: 'Upgrade now',
		Later: 'Later'
	},
	SatisfactionAssessment: 'Satisfaction assessment',
	DownloadSuccess: 'Download successfully',
	DownloadFail: 'Download fail',
	DownloadSuccessDetail: listMail =>
		`The download link has been sent to the email <strong>${listMail}</strong> please check email to download.`,
	MessageDownloadFail: 'There was an error during the download, please download again.',
	PrintSuccess: 'Print successfully',
	PrintSuccessDetail: listMail =>
		`The print link has been sent to the email ${listMail} please check email to print.`,
	PrintFail: 'There was an error during the print, please print again.',
	MessagePrintFail: 'There was an error during the print, please print again',
	New: 'New',
	SupportChannel: 'Support Channel',
	Help: 'Help',
	Setting: 'Setup',
	Message: 'Message',
	DirectToMeinvoice: 'Working with MISA meInvoice - Issuing electronic invoices',
	QuickFilter: 'Quick filter',
	ActiveStatus: 'Active status',
	All: 'All',
	NotRead: 'Not read',
	NotiType: 'Notification type',
	MarkAllAsRead: 'Mark all as read',
	UpdateIdentificationNumber: 'Update identification number',
	UpdateCCCD: {
		Title: 'Update Identification number on software',
		OrgHas: `The organization has`,
		SuccessMessage: identificationNumber =>
			`successfully updated Identification number ${identificationNumber} on License Agreement software.`,
		Instructions: `To connect the <span class='font-bold'>Accounting</span> software with the <span class='font-bold'>Invoice Processing</span> software to get invoices for accounting for <span class='font-bold'>business households using Identification number instead of Tax Code</span>, please click <span class='font-bold'>Confirm</span> to update Identification number information on the software.`,
		UpdateWarning: `During the update process, you <span class='font-bold'>cannot perform any tasks</span><div>on the software.</div>`,
		LoginChange: identificationNumber =>
			`After updating the Identification number, the organization will log into the software using Identification number <span class='font-bold'>${identificationNumber}</span>.`,
		EstimatedTime: `Estimated update time: <span class='font-bold'>5 minutes</span> (from the time you click <span class='font-bold'>Confirm</span>)`,
		ProgressTitle: 'Updating Identification number in progress',
		ProgressMessage1: `During the update process, you <span class='font-bold'>cannot perform any tasks</span> on the software.`,
		ProgressMessage2: 'We will send you a notification as soon as the update is completed.',
		CompletedMessage: identificationNumber =>
			`Identification number ${identificationNumber} update completed successfully!`,
		SuccessTitle: 'Complete updating Identification number information',
		LoginInstruction: identificationNumber =>
			`<div>From now on, the organization will log into the software</div><div>using Identification number <span class='font-bold'>${identificationNumber}</span>.</div>`,
		OrganizationInstruction: `<div>After logging back into the software, please update the Identification number in</div><div>your organizational structure.</div>`
	},
	Close: 'Close'
};
